import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const companiesAdminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'companies-admin' },
    loadComponent: () => import('./companies-admin/companies-admin.page').then((m) => m.CompaniesAdminPage),
    path: '',
  },
];
